import React from 'react'
import PropTypes from 'prop-types'
import muiThemeable from 'material-ui/styles/muiThemeable'
import { ToolbarSeparator } from 'material-ui/Toolbar'

const CustomToolbarSeparator = muiThemeable()(
  ({
    primary,
    muiTheme: {
      palette: {
        alternateTextColor,
      },
    },
    ...props,
  }) => {
    return (
      <ToolbarSeparator style={primary ? { backgroundColor: alternateTextColor } : {}} {...props}/>
    )
  }
)

CustomToolbarSeparator.propTypes = {
  primary: PropTypes.bool,
}
CustomToolbarSeparator.defaultProps = {
  primary: false,
}

export default CustomToolbarSeparator



// WEBPACK FOOTER //
// ./src/components/bars/CustomToolbarSeparator.js